import { Component, OnInit, inject, signal } from '@angular/core';
import { FiltersComponent } from '../home/filters.component';
import { ApplicationInfoService } from '../core/application-info.service';
import { PartsService } from '../core/parts.service';

@Component({
    selector: 'app-filter-bar',
    imports: [FiltersComponent],
    template: ` @if (!loading()) {
        <app-filters />
        }`,
    styles: ``
})
export class FilterBarComponent implements OnInit {
    appInfo = inject(ApplicationInfoService);
    partsService = inject(PartsService);
    loading = signal(false);

    async ngOnInit() {
        this.loading.set(true);

        await Promise.all([this.partsService.getPartTypes(), this.partsService.getMakes(), this.partsService.getPartTypeModelMaps()]);

        this.loading.set(false);
    }
}
